import React, { useState } from "react";
import { colors } from "../../../share/constants/enums";
import Button from "../../../components/common/button";
import { Link, useNavigate } from "react-router-dom";
import YupupScreen from "./../../../assets/icons/blackLogo.svg";

import { Form, Input as InputField, message } from "antd";
import { forgotPassword } from "../../../api/auth";

const ForgotPassword = () => {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const [loader, setLoader] = useState(false);

  const onFinish = (values) => {
    setLoader(true);
    localStorage.setItem("forgotPasswordEmail", values.email);
    forgotPassword(values)
      .then((res) => {
        if (res) {
          navigate("/new-password");
        }
      })
      .catch((error) => {
        message.error(error);
      })
      .finally(() => {
        setLoader(false);
      });
  };

  return (
    <div className="flex flex-col items-center h-screen justify-center">
      <div className="object-cover">
        <img
          className="block h-12 xl:h-15.3 xl:w-26.9"
          alt="yupup-screen-logo"
          src={YupupScreen}
        />
      </div>
      <div className="lg:mt-3.9 xl:mt-3.9">
        <p className="text-xl font-bold">Forgot Password? </p>
        <p className="text-lg font-normal mt-3.2">
          Please Enter your email address
        </p>
      </div>
      <Form
        form={form}
        name="myForm"
        initialValues={{
          remember: true,
        }}
        onFinish={onFinish}
      >
        <Form.Item
          className="xl:mt-7.4 xl:mb-3.2"
          name="email"
          rules={[
            {
              type: "email",
              message: "The input is not valid email!",
            },
            {
              required: true,
              message: "Please input your email!",
            },
          ]}
        >
          <InputField
            className={"w-31 h-5.4 md:w-40 lg:w-40 xl:w-40 "}
            placeholder="Email"
          />
        </Form.Item>

        <Form.Item>
          <Button
            loading={loader}
            className="w-31 md:w-40 lg:w-40 xl:w-40"
            title="Reset Password"
            color={colors.primaryPurple}
            htmlType="submit"
          />
        </Form.Item>
      </Form>

      <div className="mt-3.7 ">
        <Link to="/login" className="no-underline">
          <span className="text-grey ">Back to Login</span>
        </Link>
      </div>
    </div>
  );
};

export default ForgotPassword;
